import React, { useState } from 'react';
import { Box } from '@mui/material';
import NavBar from '../../Components/Navbar/sidenav.tsx';
import StatusFilterTabs from '../../Components/Tab/tab.tsx';
import Header from '../../Components/Header/header.tsx';
import Heading from '../../Components/Heading/heading.tsx';
import CommonTabs from './common-tab.tsx';
import QueryWidget from '../../Components/QueryWidget/query-widget.tsx'
import './driver_style.scss';

interface DriversProps {}

const Drivers: React.FC<DriversProps> = () => {
  const [activeTab, setActiveTab] = useState('Drivers');

  const handleClose = () => {};
  const handleTabChange = (newTab: string) => {
    setActiveTab(newTab);
  };
  const renderTabContent = (tab: string) => {
    switch (tab) {
      case 'Drivers':
        return <CommonTabs tabName="driver"/>;
      case 'Left':
        return <CommonTabs tabName="left"/>;
      case 'Blacklist':
        return <CommonTabs tabName="blacklist"/>;
      case 'Others':
         return <CommonTabs tabName="others"/>;
      case 'Leads':
         return <CommonTabs tabName="lead"/>;
      case 'Owner':
           return <CommonTabs tabName="owner"/>;
      default:
        return <CommonTabs tabName="driver"/>;
    }
  };

  return (
    <>
      <Header/>
      <Box sx={{ flexGrow: 1, marginTop:'70px' }}> 
        <Heading title="Drivers" closeIcon="false" onClose={handleClose} />
      </Box>
      
      <Box sx={{ marginBottom: 2, marginLeft: { xs: '10px', sm: '180px' } }}>
         <StatusFilterTabs 
            tabs={['Drivers', 'Left', 'Blacklist', 'Others', 'Leads', 'Owner']}
            activeTab={activeTab} 
            onTabChange={handleTabChange} 
         />
                            
        <Box sx={{ marginLeft: { xs: '10px', sm: '0px' } }}>
            {renderTabContent(activeTab)}
        </Box>
         <QueryWidget />
      </Box>
      <NavBar selected="Drivers" />
    </>
  );
};

export default Drivers;